import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useSelector, useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import ErrorContainer from "../../../Components/ErrorContainer";
import { yupResolver } from "@hookform/resolvers/yup";

const CompetitorForm = ({ competitorData }) => {
  const userMerchantID = useSelector(
    (state) => state?.authReducer?.user_details?.user?.merchant_id
  );

  const regMatch =
    /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;
  const dispatch = useDispatch();
  const competitorFormSchema = yup.object({
    competitor_name: yup.string().required(),
    competitor_first_url: yup
      .string()
      .matches(regMatch, "Website should be a valid URL")
      .required(),
    competitor_second_url: yup
      .string()
      .matches(regMatch, "Website should be a valid URL")
      .required(),
    competitor_third_url: yup
      .string()
      .matches(regMatch, "Website should be a valid URL")
      .required(),
  });

  const competitorDefaultState = {
    competitor_name: competitorData?.name,
    competitor_first_url: competitorData?.competitor[0]?.link,
    competitor_second_url: competitorData?.competitor[1]?.link,
    competitor_third_url: competitorData?.competitor[2]?.link,
  };
  useEffect(() => {
    competitorReset(competitorDefaultState);
  }, [competitorData]);

  const {
    register: competitorRegister,
    formState: { errors: competitorError },
    handleSubmit: competitorSubmit,
    reset: competitorReset,
    setValue: setcompetitorValue,
  } = useForm({
    resolver: yupResolver(competitorFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: competitorDefaultState,
  });

  const submitCompetitorData = (data) => {
    data = {
      competitor_id: competitorData.id,
      competitor_name: data.competitor_name,
      onlife_site_link: [
        {
          id: competitorData?.competitor[0]?.id,
          name: competitorData?.competitor[0]?.name,
          merchant_id: userMerchantID,
          onlife_site_id: competitorData?.competitor[0]?.onlife_site_id,
          link: data?.competitor_first_url,
          icon: competitorData?.competitor[0]?.name,
        },
        {
          id: competitorData?.competitor[1]?.id,
          name: competitorData?.competitor[1]?.name,
          merchant_id: userMerchantID,
          onlife_site_id: competitorData?.competitor[1]?.onlife_site_id,
          link: data?.competitor_second_url,
          icon: competitorData?.competitor[1]?.name,
        },
        {
          id: competitorData?.competitor[2]?.id,
          name: competitorData?.competitor[2]?.name,
          merchant_id: userMerchantID,
          onlife_site_id: competitorData?.competitor[2]?.onlife_site_id,
          link: data?.competitor_third_url,
          icon: competitorData?.competitor[2]?.name,
        },
      ],
    };
    dispatch(actions.postCompetitorOnlifeData(data));
  };

  return (
    <>
      <form
        // action="/onlife_sites/setup"
        // competitor_id="224"
        // id="CompetitorSetupForm"
        // method="post"
        // accept-charset="utf-8"
        // novalidate="novalidate"
        onSubmit={competitorSubmit(submitCompetitorData)}
      >
        <div class="well-header">
          <h5>
            {" "}
            <input
              {...competitorRegister("competitor_name")}
              type="text"
              // name="data[Competitor][id]"
              className="col-4"
              // id="CompetitorName"
              placeholder="Add Name For Competitor"
            />
            <ErrorContainer errors={competitorError} name="competitor_name" />
          </h5>
        </div>
        <div class="well-content no-search">
          <div class="form_row">
            <label class="field_name required">
              <em class="circle-icon yelp"></em>
              {
                competitorData?.competitor[0]?.name
              } <i class="cross-icon"></i>{" "}
            </label>
            <div class="field">
              <input
                type="hidden"
                name="data[OnlifeSiteLink][0][id]"
                value="711"
                id="OnlifeSiteLink0Id"
              />
              <input
                {...competitorRegister("competitor_first_url")}
                // name="data[OnlifeSiteLink][0][link]"
                class="col-12"
                placeholder="Add URL Here"
                // url="url"
                // maxlength="500"
                type="text"
                // id="OnlifeSiteLink0Link"
              />{" "}
              <ErrorContainer
                errors={competitorError}
                name="competitor_first_url"
              />
            </div>
          </div>
          <div class="form_row">
            <label class="field_name required">
              <em class="circle-icon hungry"></em>
              {
                competitorData?.competitor[1]?.name
              } <i class="cross-icon"></i>{" "}
            </label>
            <div class="field">
              <input
                type="hidden"
                name="data[OnlifeSiteLink][1][id]"
                value="712"
                id="OnlifeSiteLink1Id"
              />
              <input
                {...competitorRegister("competitor_second_url")}
                // name="data[OnlifeSiteLink][1][link]"
                class="col-12"
                placeholder="Add URL Here"
                // url="url"
                maxlength="500"
                type="text"
                // id="OnlifeSiteLink1Link"
              />{" "}
              <ErrorContainer
                errors={competitorError}
                name="competitor_second_url"
              />
            </div>
          </div>
          <div class="form_row">
            <label class="field_name required">
              <em class="circle-icon trip"></em>
              {
                competitorData?.competitor[2]?.name
              } <i class="cross-icon"></i>{" "}
            </label>
            <div class="field">
              <input
                type="hidden"
                name="data[OnlifeSiteLink][2][id]"
                value="713"
                id="OnlifeSiteLink2Id"
              />
              <input
                {...competitorRegister("competitor_third_url")}
                // name="data[OnlifeSiteLink][2][link]"
                class="col-12"
                placeholder="Add URL Here"
                // url="url"
                // maxlength="500"
                type="text"
                // id="OnlifeSiteLink2Link"
              />{" "}
              <ErrorContainer
                errors={competitorError}
                name="competitor_third_url"
              />
            </div>
          </div>
        </div>
        <div class="row mx-0">
          <div class="container px-0 d-flex col-12">
            <div class="btns col-4 d-flex justify-content-md-end justify-content-center py-sm-4 pt-2 pb-4 col-12">
              <button id="" type="Submit">
                Save
              </button>
              <button
                onClick={() => {
                  dispatch(
                    actions.deleteCompetitorOnlifeData({
                      id: competitorData.id,
                    })
                  );
                }}
                id="cancel"
                type="button"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

const OnlifeSitesSetup = (params) => {
  const userMerchantID = useSelector(
    (state) => state?.authReducer?.user_details?.user?.merchant_id
  );

  const dispatch = useDispatch();
  const onLifeData = useSelector((state) => state?.settingReducer?.onLifeData);

  useEffect(() => {
    dispatch(actions.getOnlifeData());
  }, []);

  const regMatch =
    /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;
  const formSchema = yup.object({
    first_url: yup
      .string()
      .matches(regMatch, "Website should be a valid URL")
      .required(),
    second_url: yup
      .string()
      .matches(regMatch, "Website should be a valid URL")
      .required(),
    third_url: yup
      .string()
      .matches(regMatch, "Website should be a valid URL")
      .required(),
  });

  const merchantDefaultState = {
    first_url: onLifeData?.merchantData[0]?.link,
    second_url: onLifeData?.merchantData[1]?.link,
    third_url: onLifeData?.merchantData[2]?.link,
  };
  useEffect(() => {
    merchantReset(merchantDefaultState);
  }, [onLifeData]);

  const {
    register: merchantRegister,
    formState: { errors: merchantError },
    handleSubmit: merchantSubmit,
    reset: merchantReset,
    setValue: setMerchantValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    reValidateMode: "onChange",
    mode: "all",
    defaultValues: merchantDefaultState,
  });
  const submitMerchantData = (data) => {
    dispatch(
      actions.postMerchantOnlifeData({
        merchant_data: [
          {
            ...onLifeData?.merchantData[0],
            link: data.first_url,
          },
          {
            ...onLifeData?.merchantData[1],
            link: data.second_url,
          },
          {
            ...onLifeData?.merchantData[2],
            link: data.third_url,
          },
        ],
      })
    );
  };

  function addCompetitors() {
    const newCompetitor = {
      id: null,
      competitor_name: "Competitor  Name",
      onlife_site_link: [
        {
          id: null,
          name: onLifeData?.merchantData[0].name,
          merchant_id: userMerchantID,
          onlife_site_id: 1,
          link: "",
          icon: "yelp",
        },
        {
          id: null,
          name: onLifeData?.merchantData[1].name,
          merchant_id: userMerchantID,
          onlife_site_id: 2,
          link: "",
          icon: "hungry",
        },
        {
          id: null,
          name: onLifeData?.merchantData[2].name,
          merchant_id: userMerchantID,
          onlife_site_id: 3,
          link: "",
          icon: "trip",
        },
      ],
    };
    dispatch(actions.postCompetitorOnlifeData(newCompetitor));
  }

  console.log("I am rendering");
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 onlife-page">
          <div className="container px-0">
            <div class="shadowclass">
              <div class="col-12">
                <div class="well light_blue">
                  <form
                    onSubmit={merchantSubmit(submitMerchantData)}
                    id="MerchantDatumSetupForm"
                    accept-charset="utf-8"
                  >
                    <div class="well-header">
                      <h5>Harry's International Pte Ltd</h5>
                    </div>
                    <div class="well-content no-search">
                      <div class="form_row">
                        <label class="field_name required">
                          <em class="circle-icon yelp"></em>
                          {onLifeData?.merchantData[0].name}{" "}
                          <i class="cross-icon"></i>{" "}
                        </label>
                        <div class="field">
                          <input
                            type="hidden"
                            name="data[MerchantDatum][0][id]"
                            value="557"
                            id="MerchantDatum0Id"
                          />
                          <input
                            {...merchantRegister("first_url")}
                            // name="data[MerchantDatum][0][link]"
                            class="col-12"
                            placeholder="Add URL Here"
                            // maxlength="500"
                            type="text"
                            // id="MerchantDatum0Link"
                            // onChange={(e) => {
                            //   setMerchantValue("first_url", e.target.value);
                            // }}
                          />{" "}
                          <ErrorContainer
                            errors={merchantError}
                            name="first_url"
                          />
                        </div>
                      </div>
                      <div class="form_row">
                        <label class="field_name required">
                          <em class="circle-icon hungry"></em>
                          {onLifeData?.merchantData[1].name}{" "}
                          <i class="cross-icon"></i>{" "}
                        </label>
                        <div class="field">
                          <input
                            type="hidden"
                            name="data[MerchantDatum][1][id]"
                            value="558"
                            id="MerchantDatum1Id"
                          />
                          <input
                            {...merchantRegister("second_url")}
                            // name="data[MerchantDatum][1][link]"
                            class="col-12"
                            placeholder="Add URL Here"
                            // maxlength="500"
                            type="text"
                            // id="MerchantDatum1Link"
                            // onChange={(e) => {
                            //   setMerchantValue("second_url", e.target.value);
                            // }}
                          />{" "}
                          <ErrorContainer
                            errors={merchantError}
                            name="second_url"
                          />
                        </div>
                      </div>
                      <div class="form_row">
                        <label class="field_name required">
                          <em class="circle-icon trip"></em>
                          {onLifeData?.merchantData[2].name}{" "}
                          <i class="cross-icon"></i>{" "}
                        </label>
                        <div class="field">
                          <input
                            type="hidden"
                            name="data[MerchantDatum][2][id]"
                            value="559"
                            id="MerchantDatum2Id"
                          />
                          <input
                            {...merchantRegister("third_url")}
                            // name="data[MerchantDatum][2][link]"
                            class="col-12"
                            placeholder="Add URL Here"
                            // maxlength="500"
                            type="text"
                            // id="MerchantDatum2Link"
                            // onChange={(e) => {
                            //   setMerchantValue("third_url", e.target.value);
                            // }}
                          />{" "}
                          <ErrorContainer
                            errors={merchantError}
                            name="third_url"
                          />
                        </div>
                      </div>
                      <div class="form_row">
                        <div class="btn-sec-row clearfix">
                          <button
                            class="btn green-btn-revert mx-0"
                            // name="submit"
                            type="submit"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="well light_blue">{/*  */}</div>
                {onLifeData?.competitors?.map((competitor) => (
                  <CompetitorForm competitorData={competitor} />
                ))}
                {/* <div id="hide_link">
                  <a href="javascript:void(0);" class="add-icon add_more">
                    Add
                  </a>
                </div> */}
              </div>

              <div onClick={addCompetitors} class="my-3">
                <a
                  id="addDependents"
                  class="btn green-btn-revert add-plus"
                  href="#_"
                >
                  <i class="i-icon"> </i> Add More..{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default OnlifeSitesSetup;
